// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__YtBAC","savePackageButton":"ClientWallet_savePackageButton__214BS"};